<template>
  <div class="my-order-container">
    <!-- 页头 -->
    <div class="gradient-header">
      <div class="checkerboard-overlay"></div>
      <div class="header-content">
        <div class="header-icon">
          <i class="el-icon-shopping-cart-2"></i>
        </div>
        <span>我的订单</span>
      </div>
    </div>

    <!-- Tab标签页 -->
    <el-tabs v-model="activeTab" class="order-tabs" @tab-click="handleTabChange">
      <el-tab-pane label="我的订单" name="myOrder">
        <!-- 搜索栏 -->
        <el-card class="search-card">
          <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item label="关键字">
              <el-input v-model="searchForm.keyword" placeholder="请输入关键字" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                <el-option label="全部" value="-1"></el-option>
                <el-option label="草稿" :value="1"></el-option>
                <el-option label="待审核" :value="2"></el-option>
                <el-option label="审核中" :value="3"></el-option>
                <el-option label="已通过" :value="4"></el-option>
                <el-option label="已拒绝" :value="5"></el-option>
                <el-option label="已取消" :value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">搜索</el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 表格 -->
        <el-card class="table-card" v-loading="loading">
          <div class="table-operations" v-if="activeTab === 'myOrder'">
            <el-button type="primary" @click="handleAdd">新建订单</el-button>
          </div>
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="order_name" label="订单名称" min-width="180"></el-table-column>
            <el-table-column prop="now_approver" label="当前审批人" min-width="120"></el-table-column>
            <el-table-column label="工作流" align="center" min-width="150">
              <template slot-scope="{row}">
                <el-tag 
                  size="medium" 
                  :type="row.now_step === 3 ? 'success' : 'info'" 
                  style="cursor: pointer"
                  @click="handleShowFlow(row)">
                  {{ row.workflow?.workFlowName || '查看流程' }}
                  <i class="el-icon-arrow-right el-icon--right"></i>
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
              <template slot-scope="{row}">
                <el-tag :type="getStatusType(row.status)">
                  {{ getStatusText(row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="金额" width="120" align="right">
              <template slot-scope="{row}">
                <span style="color: #f56c6c;">¥{{ row.money }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间" min-width="160">
              <template slot-scope="{row}">
                {{ formatDateTime(row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column prop="approve_time" label="审核时间" min-width="160">
              <template slot-scope="{row}">
                {{ row.approve_time ? formatDateTime(row.approve_time) : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="{row}">
                <el-dropdown @command="(command) => handleCommand(command, row)">
                  <span class="el-dropdown-link">
                    处理<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="view">
                      <i class="el-icon-view"></i> 查看
                    </el-dropdown-item>
                    <template v-if="activeTab === 'myOrder'">
                      <el-dropdown-item command="edit" v-if="row.status === 1">
                        <i class="el-icon-edit"></i> 明细
                      </el-dropdown-item>
                      <el-dropdown-item command="submit" v-if="row.status === 1">
                        <i class="el-icon-check"></i> 提交
                      </el-dropdown-item>
                    </template>
                    <template v-else>
                      <el-dropdown-item command="approve" v-if="[2,3].includes(row.status)">
                        <i class="el-icon-check"></i> 审核
                      </el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>


   <!-- 添加明细对话框 -->
   <el-dialog title="采购订单明细" :visible.sync="detailDialogVisible" width="800px">
      <div v-loading="detailLoading">
        <el-form :model="detailForm" ref="detailForm" label-width="100px">
          <el-table :data="detailForm.items" border style="width: 100%; margin-bottom: 20px">
            <el-table-column label="商品名称" prop="product_name" min-width="180" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.product_name }}</span>
              </template>
            </el-table-column>

            <el-table-column label="单价" width="150" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.price" :min="0" :precision="2" :step="0.01"
                  @change="calculateRowAmount(scope.$index)" size="small" controls-position="right">
                </el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="数量" width="150" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.quantity" :min="1" :precision="0" :step="1"
                  @change="calculateRowAmount(scope.$index)" size="small" controls-position="right">
                </el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="金额" width="150" align="center">
              <template slot-scope="scope">
                <span class="amount-text">{{ formatAmount(scope.row.amount) }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="total-amount">
            总金额：<span class="amount">{{ formatAmount(totalAmount) }}</span>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>




          <!-- 分页 -->
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchForm.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="searchForm.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="我的审批" name="myApproval">
        <!-- 搜索栏 -->
        <el-card class="search-card">
          <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item label="关键字">
              <el-input v-model="searchForm.keyword" placeholder="请输入关键字" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                <el-option label="全部" value="-1"></el-option>
                <el-option label="草稿" :value="1"></el-option>
                <el-option label="待审核" :value="2"></el-option>
                <el-option label="审核中" :value="3"></el-option>
                <el-option label="已通过" :value="4"></el-option>
                <el-option label="已拒绝" :value="5"></el-option>
                <el-option label="已取消" :value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">搜索</el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 表格 -->
        <el-card class="table-card" v-loading="loading">
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="order_name" label="订单名称" min-width="180"></el-table-column>
            <el-table-column prop="now_approver" label="当前审批人" min-width="120"></el-table-column>
            <el-table-column label="工作流" align="center" min-width="150">
              <template slot-scope="{row}">
                <el-tag 
                  size="medium" 
                  :type="row.now_step === 3 ? 'success' : 'info'" 
                  style="cursor: pointer"
                  @click="handleShowFlow(row)">
                  {{ row.workflow?.workFlowName || '查看流程' }}
                  <i class="el-icon-arrow-right el-icon--right"></i>
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
              <template slot-scope="{row}">
                <el-tag :type="getStatusType(row.status)">
                  {{ getStatusText(row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="金额" width="120" align="right">
              <template slot-scope="{row}">
                <span style="color: #f56c6c;">¥{{ row.money }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间" min-width="160">
              <template slot-scope="{row}">
                {{ formatDateTime(row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column prop="approve_time" label="审核时间" min-width="160">
              <template slot-scope="{row}">
                {{ row.approve_time ? formatDateTime(row.approve_time) : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="{row}">
                <el-dropdown @command="(command) => handleCommand(command, row)">
                  <span class="el-dropdown-link">
                    处理<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="view">
                      <i class="el-icon-view"></i> 查看
                    </el-dropdown-item>
                    <el-dropdown-item command="approve" v-if="[2,3].includes(row.status)">
                      <i class="el-icon-check"></i> 审核
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchForm.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="searchForm.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <!-- 添加工作流弹窗 -->
    <!-- 流程对话框 -->
    <!-- 添加工作流弹窗 -->
    <!-- 流程对话框 -->
    <el-dialog title="审批流程" :visible.sync="flowDialogVisible" width="700px" class="flow-dialog">
      <div v-loading="flowLoading">
        <el-timeline>
          <el-timeline-item v-for="(flow, index) in flowList" :key="index" :type="getTimelineNodeType(flow.status)"
            size="large">
            <div class="flow-item">
              <!-- 节点标题和状态 -->
              <div class="flow-header">
                <span class="flow-title">
                  <span class="step-tag">步骤 {{ flow.step }}</span>
                  {{ flow.title }}
                </span>
                <el-tag size="mini" :type="getStatusTagType(flow.status)">
                  {{ flow.statusText }}
                </el-tag>
              </div>

              <!-- 审批人信息 -->
              <div class="flow-content">
                <div class="flow-info">
                  <div class="info-header">
                    <i class="el-icon-user"></i>
                    <span>审批人</span>
                  </div>
                  <div class="approver-list">
                    <template v-if="flow.approverDetails && flow.approverDetails.length">
                      <div v-for="(approver, idx) in flow.approverDetails" :key="idx" class="approver-item">
                        <div class="approver-info">
                          <!-- 审批人名字和状态 -->
                          <div class="approver-row">
                            <span class="approver-name">{{ approver.name }}</span>
                            <el-tag size="mini" :type="getStatusTagType(approver.status)">
                              {{ getApproverStatusText(approver.status) }}
                            </el-tag>
                            <span class="approve-time">
                              {{ approver.time ? formatDateTime(approver.time) : '' }}
                            </span>
                          </div>
                          <!-- 审核意见直接跟在审批人下方 -->
                          <div v-if="approver.comment" class="approve-comment">
                            审核意见：{{ approver.comment }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <span v-else class="no-approver">待处理</span>
                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { submitPurchaseOrder } from '@/api/purchase'

export default {
  name: 'MyOrder',
  data() {
    return {
      loading: false,
      flowDialogVisible: false,
      detailDialogVisible: false,
      detailLoading: false,
      flowLoading: false,
      flowList: [],
      activeTab: 'myOrder',
      detailForm: {
        items: [],
        totalAmount: 0
      },
      searchForm: {
        page: 1,
        size: 10,
        keyword: '',
        status: -1,
        type: 1  // 1-我创建的订单，2-我参与审批的订单
      },
      tableData: [],
      total: 0
    }
  },
  computed: {
    totalAmount() {
      return this.detailForm.items.reduce((sum, item) => sum + (item.amount || 0), 0)
    }
  },
  created() {
    // 从路由参数获取type
    const type = Number(this.$route.query.type) || 1
    this.searchForm.type = type
    this.activeTab = type === 1 ? 'myOrder' : 'myApproval'
    this.fetchData()
  },
  methods: {
    // 时间格式化函数
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },

    // 获取订单列表
    async fetchData() {
      try {
        this.loading = true
        const response = await request({
          url: '/api/v1/purchasing-order/user-related-list',
          method: 'post',
          data: {
            page: this.searchForm.page,
            size: this.searchForm.size,
            keyword: this.searchForm.keyword,
            status: this.searchForm.status,
            type: this.searchForm.type  // 使用searchForm中的type
          }
        })

        console.log('API Response:', response)

        if (response.status === 1 && response.data) {
          this.tableData = response.data.list || []
          this.total = response.data.total || 0
          console.log('Processed orderList:', this.tableData)
        } else {
          throw new Error(response.message || '获取订单列表失败')
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.$message.error(error.message || '获取订单列表失败')
      } finally {
        this.loading = false
      }
    },

    // 切换标签页
    handleTabChange(tab) {
      // 根据标签页设置type
      this.searchForm.type = tab.name === 'myOrder' ? 1 : 2
      this.searchForm.page = 1  // 重置分页
      // 更新路由参数
      this.$router.push({
        query: {
          ...this.$route.query,
          type: this.searchForm.type
        }
      })
      this.fetchData()  // 重新获取数据
    },

    // 重置搜索表单
    resetForm() {
      this.searchForm = {
        page: 1,
        size: 10,
        keyword: '',
        status: -1,
        type: this.activeTab === 'myOrder' ? 1 : 2  // 保持当前标签页的type
      }
      this.fetchData()
    },

    // 查看订单详情
    handleView(row) {
      this.$router.push({
        path: '/purchase/myorder/detail',
        query: { 
          orderId:  row.purchasing_order_id  // 添加 orderId 参数
        }
      })
    },

    // 处理工作流显示
    async handleShowFlow(row) {
      this.flowLoading = true
      this.flowDialogVisible = true

      try {
        if (row.workflow?.nodes && row.workflow.nodes.length > 0) {
          this.flowList = row.workflow.nodes.map(node => ({
            title: `${node.nodeName} ${this.getNodeTypeText(node.nodeType)}`,
            step: node.step,
            status: node.status,
            statusText: this.getNodeStatusText(node.status),
            approverDetails: node.approvers?.map(approver => ({
              name: approver.approver,
              status: approver.status,
              time: approver.approverTime,
              comment: approver.approverRemark
            })) || []
          }))
        } else {
          this.flowList = [{
            title: '暂无流程数据',
            step: 1,
            status: 0,
            statusText: '未开始',
            approverDetails: []
          }]
        }
      } catch (error) {
        console.error('处理流程数据失败:', error)
        this.$message.error('处理流程数据失败')
      } finally {
        this.flowLoading = false
      }
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        1: '草稿',
        2: '待审核',
        3: '审核中',
        4: '已通过',
        5: '已拒绝',
        6: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        1: '',        // 草稿
        2: 'warning', // 待审核
        3: 'info',    // 审核中
        4: 'success', // 已通过
        5: 'danger'   // 已拒绝
      }
      return statusMap[status] || ''
    },

    // 获取节点类型文本
    getNodeTypeText(nodeType) {
      const typeMap = {
        1: '(串行审批)',
        2: '(并行与)',
        3: '(并行或)'
      }
      return typeMap[nodeType] || ''
    },

    // 分页方法
    handleSizeChange(val) {
      this.searchForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.fetchData()
    },

    // 获取时间线节点类型
    getTimelineNodeType(status) {
      switch (status) {
        case 2: return 'success'  // 已完成
        case 1: return 'primary'  // 进行中
        case 0: return 'info'     // 未开始
        case 3: return 'danger'   // 已拒绝
        case 4: return 'warning'  // 已取消
        default: return 'info'
      }
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'danger',  // 已拒绝
        3: 'success', // 已通过
        4: 'info',    // 已转交
        5: 'warning'  // 已回退
      }
      return typeMap[status] || 'info'
    },

    // 获取审批人状态文本
    getApproverStatusText(status) {
     // 将 status 转换为数字类型，以确保正确匹配
     const statusNum = Number(status);

const statusMap = {
  0: '未处理',
  1: '处理中',
  2: '已拒绝',
  3: '已通过',
  4: '已转交',
  5: '已回退'
}

// 添加调试日志
console.log('Approver status:', status, 'Mapped status:', statusMap[statusNum]);

return statusMap[statusNum] || '未知状态';
    },

    // 获取节点状态文本
    getNodeStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已完成',
        3: '已拒绝',
        4: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 明细订单
    handleEdit(row) {
      this.detailDialogVisible = true
      this.detailLoading = true

      try {
        const details = row.order_details || []
        this.detailForm.items = details.map(item => ({
          product_name: item.goods_name || '未知商品',
          price: item.price || 0,
          quantity: item.quantity || 0,
          amount: item.total_amount || 0,
          detail_id: item.detail_id
        }))
      } catch (error) {
        console.error('处理订单明细失败:', error)
        this.$message.error('处理订单明细失败')
        this.detailForm.items = []
      } finally {
        this.detailLoading = false
      }
    },
    async calculateRowAmount(index) {
      const row = this.detailForm.items[index]
      if (!row) return
      row.amount = row.price * row.quantity
      try {
        // 调用接口更新商品明细
        const res = await request({
          url: '/api/v1/purchasing-order/detail/update',
          method: 'post',
          data: {
            detail_id: row.detail_id,
            price: row.price,
            quantity: row.quantity
          }
        })

        if (res.status === 1) {
          // 更新成功后重新计算金额
          row.amount = row.price * row.quantity
          this.$message.success('更新成功')
          await this.fetchData()
        } else {
          this.$message.error(res.msg || '更新失败')
          // 更新失败时回滚数据
          await this.fetchData()
        }
      } catch (error) {
        console.error('更新商品明细失败:', error)
        this.$message.error('更新失败')
        // 发生错误时回滚数据
        await this.fetchData()
      }
    


  },
  //
  formatAmount(amount) {
    return `¥${amount.toFixed(2)}`
  },
    // 提交订单
    async handleSubmit(row) {
      this.$confirm('确认提交审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await submitPurchaseOrder(row.purchasing_order_id)
          this.$message.success('提交成功')
          await this.fetchData() // 刷新列表
        } catch (error) {
          console.error('提交审核失败:', error)
          this.$message.error(error.message || '提交失败')
        }
      }).catch(() => {
        // 用户取消操作，不做处理
      })
    },

    // 取消订单
    async handleCancel(row) {
      try {
        await this.$confirm('确定要取消该订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await request({
          url: '/api/v1/purchasing-order/cancel',
          method: 'post',
          data: {
            purchasing_order_id: row.purchasing_order_id
          }
        })

        if (response.status === 1) {
          this.$message.success('取消成功')
          this.fetchData()
        } else {
          throw new Error(response.message || '取消失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(error.message || '取消失败')
        }
      }
    },
    // async handleApprove(row) {
    //   this.$router.push({
    //     path: '/purchase/myorder/detail',
    //     query: { 
    //       orderId: row.purchasing_order_id,
    //       mode: 'approve'
    //     }
    //   })
    // },

    // 处理下拉菜单命令
    handleCommand(command, row) {
      console.log('订单数据:', row) 
      switch (command) {
        case 'view':
          this.handleView(row)
          break
        case 'edit':
          this.handleEdit(row)
          break
        case 'submit':
          this.handleSubmit(row)
          break
        case 'cancel':
          this.handleCancel(row)
          break
        case 'approve':
          this.handleApprove(row)
          break
      }
    },

    // 处理搜索
    handleSearch() {
      this.searchForm.page = 1  // 重置页码
      this.fetchData()
    },

    // 处理添加新订单
    handleAdd() {
      this.$router.push({
        path: '/purchase/myorder/detail',
        query: { mode: 'add' }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-input-number {
  width: 100%;
}
::v-deep .el-input-number {
  width: 100%;

  .el-input__inner {
    text-align: right;
  }
}
.my-order-container {
  padding: 20px;
}
.amount-text {
  color: #606266;
  font-weight: 500;
}
.total-amount {
  text-align: right;
  margin-top: 20px;
  padding-right: 20px;
  font-size: 14px;

  .amount {
    font-size: 18px;
    color: #f56c6c;
    margin-left: 8px;
    font-weight: bold;
  }
}
/* 渐变动画页头样式 */
.gradient-header {
  height: 80px;
  background: linear-gradient(90deg, #409EFF 0%, #40E0D0 100%);
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 24px;
  color: white;
  font-size: 18px;
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: hidden;
}

/* 棋盘格纹理遮罩 */
.checkerboard-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}

/* 内容层 */
.header-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.header-icon {
  margin-right: 12px;
}

.header-icon i {
  font-size: 24px;
}

.order-tabs {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.search-card {
  margin-bottom: 20px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
}

.table-card {
  margin-bottom: 20px;
}

.table-operations {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.flow-dialog {
  .flow-container {
    padding: 20px 10px;
  }

  ::v-deep .el-timeline {
    padding: 0 20px;

    .el-timeline-item {
      padding-bottom: 25px;

      &:last-child {
        padding-bottom: 0;
      }

      .el-timeline-item__node {
        &--large {
          width: 14px;
          height: 14px;
        }

        &.is-success {
          background-color: #67C23A;
        }

        &.is-warning {
          background-color: #E6A23C;
        }

        &.is-danger {
          background-color: #F56C6C;
        }
      }

      .el-timeline-item__wrapper {
        padding-left: 25px;
      }

      .el-timeline-item__timestamp {
        color: #909399;
        font-size: 13px;
        margin-bottom: 8px;
      }
    }
  }

  .flow-item {
    background: #f8f9fa;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 10px;

    .flow-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .flow-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;

        .step-tag {
          background: #ecf5ff;
          color: #409eff;
          padding: 2px 6px;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 12px;
        }
      }
    }

    .flow-content {
      .flow-info {
        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          color: #606266;

          i {
            margin-right: 5px;
          }
        }

        .approver-list {
          .approver-item {
            padding: 10px 0;
            border-bottom: 1px dashed #ebeef5;

            &:last-child {
              border-bottom: none;
            }

            .approver-info {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }

            .approver-row {
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .approve-comment {
              color: #606266;
              font-size: 13px;
              padding-left: 2px;
            }
          }
        }

        .no-approver {
          color: #909399;
          font-size: 13px;
        }
      }
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-dropdown-link:hover {
  color: #66b1ff;
}

/* 为取消按钮添加红色样式 */
:deep(.danger-item) {
  color: #F56C6C;
}

:deep(.danger-item:hover) {
  background-color: #fef0f0;
  color: #F56C6C;
}

:deep(.danger-item i) {
  color: #F56C6C;
}

:deep(.el-dropdown-menu__item i) {
  margin-right: 5px;
}
</style> 